/**
 * 专家手机号展示权限（与专家编辑页 legacy 中手机号字段规则一致）
 */

/** 有用户查询权限的管理员 ID 列表 */
export const EXPERT_MOBILE_PRIVILEGED_ADMIN_IDS = [
    28, // 赵红
    48, // 王娜
    56, // 王新桐
    57, // 赵晓苗
    71, // 南兴君
    77, // 孙浩
    92, // 闫荣伟
    233, // 明延飞
    141, // 赵静
    266, // 张金萍

    19, // 胡志飞
];

/**
 * 当前登录管理员 ID（来自 localStorage，与编辑页一致）
 */
export function getCurrentExpertAdminId() {
    let adminId = 0;
    const adminInfo = localStorage.getItem('infos');
    if (adminInfo && JSON.parse(adminInfo)) {
        const info = JSON.parse(adminInfo)?.data;
        adminId = JSON.parse(info)?.id;
    }
    return adminId;
}

/**
 * 是否存在「正式」主手机号（非占位、非 100 开头，且为 11 位 1 开头号码）
 */
export function hasFormalExpertMobile(memMobile) {
    if (!memMobile || String(memMobile).startsWith('100')) {
        return false;
    }
    return /^1\d{10}$/.test(String(memMobile));
}

/**
 * 是否可查看完整主/其他手机号：无正式主手机号时所有人可看；有正式主手机号时仅特权管理员可看完整号码
 * @param {string} memMobile 主手机号（可与编辑页 formalMobile 或接口 memMobile 一致）
 */
export function canViewExpertMobileFull(memMobile) {
    if (!hasFormalExpertMobile(memMobile)) {
        return true;
    }
    return EXPERT_MOBILE_PRIVILEGED_ADMIN_IDS.indexOf(getCurrentExpertAdminId()) > -1;
}

/**
 * 手机号脱敏展示（11 位中国手机号为 138****5678）
 */
export function maskExpertMobileDisplay(mobile) {
    if (mobile === null || mobile === undefined || mobile === '') {
        return '';
    }
    const s = String(mobile);
    if (/^1\d{10}$/.test(s)) {
        return s.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
    }
    if (s.length <= 4) {
        return '****';
    }
    return `${s.slice(0, 3)}****${s.slice(-4)}`;
}
